import { useCallback } from 'react';
import { useGamePurchases } from './useGamePurchases';
import { useGameState } from './useGameState';
import { GAME_CONFIG } from '../config/game';

export function useGameCalculations(walletAddress: string | null) {
  const { calculateTotalBonus, calculateMultiplier } = useGamePurchases(walletAddress);
  const { gameState, updateGameState } = useGameState(walletAddress);

  // Calculer les gains par clic
  const calculateClickGains = useCallback(() => {
    // Utiliser directement coinsPerClick comme valeur de base
    let value = gameState.coinsPerClick || 1;
    
    // Appliquer le bonus de niveau
    const levelBonus = Math.pow(GAME_CONFIG.levelUpMultiplier, gameState.level - 1);
    value = Math.floor(value * levelBonus);
    
    // Vérifier les coups critiques
    const isCritical = Math.random() < GAME_CONFIG.criticalClickChance;
    if (isCritical) {
      value = Math.floor(value * GAME_CONFIG.criticalClickMultiplier);
    }

    // Calculer l'expérience gagnée (proportionnelle aux gains)
    const expGained = Math.max(1, Math.floor(value * 0.1));
    
    // Mettre à jour l'expérience
    updateGameState({
      experience: gameState.experience + expGained
    });
    
    return {
      value,
      isCritical,
      expGained
    };
  }, [gameState.coinsPerClick, gameState.level, gameState.experience, updateGameState]);

  // Calculer la valeur des auto-clickers
  const calculateAutoClickValue = useCallback(() => {
    const { value } = calculateClickGains();
    return value * gameState.autoClickerCount;
  }, [calculateClickGains, gameState.autoClickerCount]);

  return {
    calculateClickGains,
    calculateAutoClickValue
  };
}